/* Regnum waitlist persist.
   Xtra re-renders the whole product form (.f8pr-buy-button) via the Section
   Rendering API on every variant change. The back-in-stock app (Essential)
   injects its "Notify me when available" button into .regnum-waitlist-wrap
   only once, on initial page load — so after a variant click the injected
   button is wiped and the disabled "Out of stock" fallback shows instead.

   This script keeps a live reference to the app's injected node(s) and
   re-attaches them whenever the wrap is re-rendered without them. Re-using
   the same DOM nodes (not clones) preserves the app's event listeners. */
(function () {
  'use strict';

  var savedNodes = null;

  function appNodesIn(wrap) {
    return Array.prototype.filter.call(wrap.children, function (child) {
      return !child.classList.contains('regnum-waitlist-fallback');
    });
  }

  function sync() {
    var wrap = document.querySelector('.regnum-waitlist-wrap');
    if (!wrap) return; // selected variant is purchasable — keep saved nodes parked
    var present = appNodesIn(wrap);
    if (present.length) {
      savedNodes = present;
      return;
    }
    if (savedNodes) {
      savedNodes.forEach(function (node) {
        if (!node.isConnected) wrap.appendChild(node);
      });
    }
  }

  function init() {
    var content = document.getElementById('content') || document.body;
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      // Let the theme's own re-render handling (and the app, on first load)
      // finish before we look at the result.
      setTimeout(function () {
        scheduled = false;
        sync();
      }, 50);
    });
    observer.observe(content, { childList: true, subtree: true });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
